enum BoxArrangement {
  OneSKUPerBox = "OneSKUPerBox",
  MultipleSKUsPerBox = "MultipleSKUsPerBox",
}

export default BoxArrangement;
